import { render, staticRenderFns } from "./LastViewedImageCarousel.vue?vue&type=template&id=68c8910e&"
import script from "./LastViewedImageCarousel.vue?vue&type=script&lang=js&"
export * from "./LastViewedImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68c8910e')) {
      api.createRecord('68c8910e', component.options)
    } else {
      api.reload('68c8910e', component.options)
    }
    module.hot.accept("./LastViewedImageCarousel.vue?vue&type=template&id=68c8910e&", function () {
      api.rerender('68c8910e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O8L2ShFSGyBz/JS/comp/LastViewedImageCarousel.vue"
export default component.exports